import {
    provideKeycloak,
    createInterceptorCondition,
    IncludeBearerTokenCondition,
    INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    withAutoRefreshToken,
    AutoRefreshTokenService,
    UserActivityService
} from 'keycloak-angular';
import { environment } from '../environments/environment';

export const provideKeycloakAngular = () =>
    provideKeycloak({
        config: {
            url: environment.authServer,
            realm: environment.authRealm,
            clientId: environment.authClientId
        },
        initOptions: {
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/assets/keycloak/silent-check-sso.html',
            redirectUri: window.location.origin + '/'
        },
        features: [
            withAutoRefreshToken({
                onInactivityTimeout: 'logout',
                sessionTimeout: 60000
            })
        ],
        providers: [
            AutoRefreshTokenService,
            UserActivityService
        ]
    });